$(function(){
  
  var sizeSelected = {};
  
  var zooming = false;
  /////////////////////////MRIGANKA/////////////////////////
  var selectedSize;
  /////////////////////////MRIGANKA/////////////////////////
  
  // size is not selected by default . 
  // keep an array of the products where the user
  // has selected a size so that it can be checked when the Add
  // to cart button is clicked
  
  $("input:checked[name='option-0']").each( function(e) {
    // automatically add products with only one option - already marked as checked in liquid
    var productId =  $(this).parents('form').attr('data-id');
    sizeSelected[productId] = true;
  });
  
  $("input[name='option-0']").click( function(e) {
    var productId =  $(this).parents('form').attr('data-id');
    sizeSelected[productId] = true;
  });

  
  //Update Front/Back Popup
  function imagePopupUpdate(color){
    var $image = $('.image-popup[alt="'+color+'"]');
    $('.image-popup').removeClass('active-img_first active-img_second').hide(); 
    if($image.length){ 
      $image.addClass('active-img_first').show().next().addClass('active-img_second'); 
    }else{
      $('.image1').addClass('active-img_first').show();
      $('.image2').addClass('active-img_second');
    }
  }

  //Update sub-product image
//   function updateFeatureImage(e){
//     var $this = e;
//     var $featuredImage =  $this.closest('.product-item').find('.product_image').find('img'); 
//     var color = $this.closest('.color').attr('data-value'); 
//     var meta=  $this.closest('.product-item').find('meta[data-alt="'+color+'"]');
    
    
//     var src = meta.attr('data-src');
//     $featuredImage.attr("src", src);
       
//     var owl = $('.pdp-carousel');
//         owl.owlCarousel({
//           items:1,
//           nav: false, 
//           dots: false,
//           margin:10,
//           autoHeight:true,
//         });

//   }
  
  /////////////////////////MRIGANKA/////////////////////////
  //Update sub-product image
  function updateFeatureImage(e, position){
    var $this = e;
    var color = $this.closest('.color').attr('data-value');
    var metaDataIndex;
    var meta;
    var metaDataSelectedColor = color.split('-')[0];    
    var swcol;
    
    //To update Top/bottom carousel slider images - START
    var eci_position = '.pdp-carousel-'+position + ' .owl-stage-outer .owl-stage';
    $(eci_position).children().each(function () {
      	
      meta = $(this).find('.product-item .grid .product-item_image .product_image--container meta[data-alt^="' + metaDataSelectedColor + '"]');

      var src = meta.attr('data-src');
      var $featuredImage = $(this).find('.product-item .grid .product-item_image div').find('.product_image').find('img');
      $featuredImage.attr("src", src);
      //console.log(metaDataIndex, src); // "this" is the current element in the loop
      
	});
    //To update Top/bottom carousel slider images - END
    
    var owl = $('.pdp-carousel');
        owl.owlCarousel({
          items:1,
          nav: false, 
          dots: false,
          margin:10,
          autoHeight:true,
        });

  }  
  /////////////////////////MRIGANKA/////////////////////////

  //Update product info on load // see bottom of product-template.liquid
  //var colorSwatch = $('meta[data-id="product-color"]').attr('data-color');
  //var colorSwatchBottom = $('meta[data-id="product-color-bottom"]').attr('data-color');
  //var $thisTop =  $('.color[data-value="'+colorSwatch+'"]').find('input');
  //var $thisBottom =  $('.color[data-value="'+colorSwatchBottom+'"]').find('input');
  //$('.color[data-value="'+colorSwatch+'"]').children().trigger("click"); 
  //$('.color[data-value="'+colorSwatchBottom+'"]').children().trigger("click"); 
  

  
  //updateFeatureImage($thisTop);
  //updateFeatureImage($thisBottom);

  //Product variant update 
  $('.type_all :radio, .type_top :radio, .type_bottom :radio').on('click',function() {
    
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    var color, size, location, variantTitle; 
    var $optherSwatchOptions = $(this).closest('.product-item').find('.swatch:not([data-option-index="' + optionIndex + '"])');
    //console.log('optionIndex: '+ optionIndex);
    
    $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change'); 
    $(this).closest('form').find('.single-option-selector-bottom').eq(optionIndex).val(optionValue).trigger('change'); 

    if(optionIndex == 0){
      size = optionValue; 
      color = $(this).closest('form').find('.SingleOptionSelector-1').val();
      location = $(this).closest('form').find('.SingleOptionSelector-2').val();
    }
    if(optionIndex == 1){ 
      size = $(this).closest('form').find('.SingleOptionSelector-0').val();
      color = optionValue;
      location = $(this).closest('form').find('.SingleOptionSelector-2').val();
    }
 	if(optionIndex == 2){ 
      size = $(this).closest('form').find('.SingleOptionSelector-0').val();
      color = $(this).closest('form').find('.SingleOptionSelector-1').val();
      location = optionValue;
    }
	
    //console.log('size: '+size);
    //console.log('color: '+color);
    //console.log('location: '+location);
    /////////////////////////MRIGANKA/////////////////////////    
    selectedSize = size;
    /////////////////////////MRIGANKA/////////////////////////
    
    var index = $(".single-option-selector").prop('selectedIndex');
    var combined_value = size+" / " + color; 
    var currentOption = 1+parseInt(optionIndex);
    var productJSON = JSON.parse($(this).closest('.product-item').find('.__ProductJson').html());
    var $product_price = $(this).closest('form').find('.product-price__container'); 
 
    $optherSwatchOptions.find('.swatch-element').addClass('soldout');
    $(this).closest('.product-item').find('.swatch-element input').attr('disabled', false);
    $.each(productJSON.variants, function(i, variant){
      //console.log('variant Title: '+variant.title);
      //console.log('combined Value: '+ combined_value);
      
      // we remove the location from variant title
       variantTitle = variant.title.split(' / ');
       variantTitle = variantTitle[0]+' / '+ variantTitle[1];
      //console.log('variantTitle: '+variantTitle);
      
      if(variantTitle == combined_value){
         //console.log('variant Title: '+variant.title);
         //console.log('combined Value: '+ combined_value);
        var comparePrice = variant.compare_at_price * .01;
        var maxPrice = variant.price * .01;
        //console.log('price change:'+maxPrice.toFixed(2));
        if(maxPrice < comparePrice){
          //console.log('onsale: '+maxPrice.toFixed(2) + ' : '+ comparePrice.toFixed(2));
          $product_price.html('<span class="visually-hidden">Regular price</span> <s class="product-price__price"><span class="money">€'+comparePrice.toFixed(2)+'</span></s> <span class="product-price__price product-price__sale" style="color:#a31313 !important;"><span class="money">€'+maxPrice.toFixed(2)+'</span>');
        }
        else{
          $product_price.html('<span class="money"><span class="visually-hidden">Regular price</span><span class="product-price__price">€'+maxPrice.toFixed(2)+'</span></span>');
        }
        
       // if(maxPrice < comparePrice){
       //   console.log('onsale: '+maxPrice.toFixed(2) + ' : '+ comparePrice.toFixed(2));
       //   $product_price.html('<span class="visually-hidden">Regular price</span> <s class="product-price__price">$'+comparePrice.toFixed(2)+'</s> <span class="product-price__price product-price__sale">$'+maxPrice.toFixed(2)+' <span class="product-price__sale-label">Sale</span></span>');
       // }
       // else{
       //   $product_price.html('<span class="money"><span class="visually-hidden">Regular price</span><span class="product-price__price">$'+maxPrice.toFixed(2)+'</span></span>');
       // }

      }
      
      if( variant.available && variant["option" + currentOption] == optionValue ) {
        var optIndex = 1 + parseInt($optherSwatchOptions.attr('data-option-index'));
    
        var selectedSwatch = $optherSwatchOptions.find('.swatch-element[data-value="' + variant["option" + optIndex] + '"]');
        selectedSwatch.removeClass('soldout'); 
        
      }
    });
    
    $(this).closest('.product-item').find('.swatch-element.soldout input').attr('disabled', true);
    $(this).closest('.product-item').find('.swatch-element.soldout input:checked').each(function(){
      if( $(this).is(":disabled") ){
        $(this).closest('.swatch').find('.swatch-element:not(.soldout) input').first().attr('checked', true);
      }
    });
    
    //console.log('combined: '+ combined_value);
    
    // main variant select that goes to cart//
    $(this)
    .closest('form')
    .find('.product-form__variants option').each(function(i){

      var value = $(this).attr('data-name'); 
      //console.log('value: '+ value);
      if(value == combined_value){ 
        //console.log(value+' -- '+combined_value);
        //$(this).closest('select').val($(this).val()).trigger('change');
        $(this).closest('select').val($(this).val());
        //console.log($(this).val());
      }
      else{
        $(this).attr("selected",false);
      }

    });   
  });

  //Add to cart
  $('.product-form__cart-submit').click(function(e){
    e.preventDefault();
    var $this = $(this);

    var productID = $this.closest('form').attr('data-id');
    var selectElement = $(this).closest('form[data-id="'+productID+'"]').find('.product-form__variants');
    var variantID = $(selectElement).val(); 
    console.log(variantID);
    if (!sizeSelected[productID]) {
      $('#size-error-message-' + productID).removeClass('hide');
      return;
    }
    
    if($('#CartCount span').length > 0){
    	var CartValue = $('#CartCount span').html();
    }else{
     	var CartValue = 0; 
    }
    
    CartJS.addItem(variantID, 1, {}, {
      "success": function(data, textStatus, jqXHR) { 
        
        $.get("/pages/minicart", function( data ) {
          $('#cartContents').html( data );
        });
        
        if(parseInt(CartValue) == 0){
          $('.cart-container').append('<div id="CartCount" class="site-header__cart-count"><span>1</span><span class="icon__fallback-text medium-up--hide">item</span></div>');
        }else{
          $('#CartCount span').html(parseInt(CartValue)+1);
        }
        
        $('#addcartconfirmation').fadeIn();
        
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log('Cart Error: ' + errorThrown + '!');
      }
    });
  });
  


  //Popup Front/Back event
  $('.product_image').click(function(){
    
    if (window.innerWidth < 900) {
      return;
    }
    
    var img_id = $(this).attr('data-id') 
    var color = $(this).closest('.product-item').find('form').find('.color input[type="radio"]:checked').attr('value');
    imagePopupUpdate(color);
    $("#"+img_id).fadeIn(); 
  });  

  //Events based on color change
  $('.color ').on('click',function(){
    var color = $(this).attr('data-value');  
    var $positon = $(this).attr('class').indexOf('top') > -1 ? 'top':'bottom';
    var $featuredImage =  $(this).closest('.product-item').find('.product_image').find('img');
    var $currentSwath = $(this).find('input');

    if($currentSwath.is(':enabled')) {
        // Do enabled radio button code here 
       updateFeatureImage($currentSwath, $positon);
       imagePopupUpdate(color);
    }
    else {
        // Do disabled radio button code here
    }   
  });
  
  function getFrontBackImages($this) {
    
    var images = [];

    var color = $this.closest('.product-item').find('form').find('.color input[type="radio"]:checked').attr('value');
       
    var $image = $('.image-popup[alt="'+color+'"]');
    //alert(color);
    
    if($image.length){
      images.push($image[0].src);
      var backSrc = $image.next().attr('src');
      images.push(backSrc);
    }else{
      var productJSON = JSON.parse($this.closest('.product-item').find('.__ProductJson').html());
      images.push(productJSON.images[0]);
      images.push(productJSON.images[1]);
    }

    return images;
  }
  
  // view back on mobile
  $('.v-back-mobile').click(function(e) {
    
    var images = getFrontBackImages($(this));
    
    swapFrontBack(this, images[1]);
        
    
  });

  $('.v-front-mobile').click(function(e) {
    
    var images = getFrontBackImages($(this));
    
    swapFrontBack(this, images[0]);
    
  });

  function swapFrontBack(el, src) {
  
    var featImage =  $(el)
    	.closest('.product-item')
    	.find('.product_image')
        .find('img');
    
    $(featImage).attr('src', src);
    
  }
  
  function featuredImage(el) {
    $(el).closest('.product-item').find('.product_image').find('img');
  }
  
    var mobileCheck = function () {
    var userAgent = false;
    var mobileWidth = false;
    if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
       ) {
      userAgent = true;
    }
    else {
      userAgent =  false;
    }
    if(window.innerWidth <= 800 && window.innerHeight <= 600) {
      mobileWidth = true;
    } else {
      mobileWidth =  false;
    }

    //             alert( "UA: "+userAgent +" MW: "+ mobileWidth);
    return (userAgent || mobileWidth);
  };
  

  if(!mobileCheck()){
    $('.product-mobile-thumbs-slider-top').slick({
      lazyLoad: 'ondemand',
      dots: false,
      infinite: false,
      slidesToShow: 3, 
      slidesToScroll: 1,
      arrow: true,
      prevArrow:'<i class="fa arrow-slick fa-chevron-left"></i>',
      nextArrow:'<i class="fa arrow-slick fa-chevron-right"></i>'
    });

    $('.product-mobile-thumbs-slider-bottom').slick({
      lazyLoad: 'ondemand',
      dots: false,
      infinite: false,
      slidesToShow: 3, 
      slidesToScroll: 1,
      arrow: true,
      prevArrow:'<i class="fa arrow-slick fa-chevron-left"></i>',
      nextArrow:'<i class="fa arrow-slick fa-chevron-right"></i>'
    });
    
  }else{
    $('.product-mobile-thumbs-slider-top').slick({
      lazyLoad: 'ondemand',
      dots: false,
      infinite: false,
      slidesToShow: 4, 
      slidesToScroll: 1,
      arrows: false
    });
    
    $('.product-mobile-thumbs-slider-bottom').slick({
      lazyLoad: 'ondemand',
      dots: false,
      infinite: false,
      slidesToShow: 4, 
      slidesToScroll: 1,
      arrows: false
    });
  }
  
  /////////////////////////MRIGANKA/////////////////////////
  $('.swcol-top').on('change', function() {
    
    
    
    var colorArrTop = $(this).data('col');
    var filterClassTop = colorArrTop.split('-'); 
    //console.log('COLOR:'+filterClassTop[0]);
    console.log('COLOR: '+filterClassTop[0]);
    $('.product-mobile-thumbs-slider-top').slick('slickUnfilter');
    $('.product-mobile-thumbs-slider-top').slick('slickFilter', '.' + filterClassTop[0]);
  });
  
    $('.swcol-bottom').on('change', function() {
    var colorArrBottom = $(this).data('col');
    var filterClassBottom = colorArrBottom.split('-'); 
    //console.log('COLOR:'+filterClassBottom[0]);
    $('.product-mobile-thumbs-slider-bottom').slick('slickUnfilter');
    $('.product-mobile-thumbs-slider-bottom').slick('slickFilter', '.' + filterClassBottom[0]);
  });  
  /////////////////////////MRIGANKA/////////////////////////
    
  
  $('.product-thumbs-next-top').on('click',function(e) {
     $('.product-mobile-thumbs-slider-top').slick('slickNext');
  });

  $('.product-thumbs-prev-top').on('click', function(e) {
     $('.product-mobile-thumbs-slider-top').slick('slickPrev');
  });

  $('.product-thumbs-next-bottom').on('click',function(e) {
     $('.product-mobile-thumbs-slider-bottom').slick('slickNext');
  });

  $('.product-thumbs-prev-bottom').on('click', function(e) {
     $('.product-mobile-thumbs-slider-bottom').slick('slickPrev');
  });

  
//   $('.product-thumbs-link-top').on('click', function(e) {
//       var link = $(this);
//       var slide = link.attr('data-slide-index');
       
//       var index = parseInt(slide,10);
//       try {
//         var owl = $('.pdp-carousel-top');
//         owl.trigger('to.owl.carousel', [index, 300]);
//       } catch (ex) {
//         console.log(ex);
//       }
       
//   });

//   $('.product-thumbs-link-bottom').on('click', function(e) {
//       var link = $(this);
//       var slide = link.attr('data-slide-index');
       
//       var index = parseInt(slide,10);
//       try {
//         var owl = $('.pdp-carousel-bottom');
//         owl.trigger('to.owl.carousel', [index, 300]);
//       } catch (ex) {
//         console.log(ex);
//       }
//   });
  
  	/////////////////////////MRIGANKA/////////////////////////
    $('.product-thumbs-link-top').on('click', function(e) {
      var img_id = $(this).data('id');      
      var link = $(this);
      var slide = link.attr('data-slide-index');    
      var index = parseInt(slide,10);
      var selectedDataColor = $(this).attr('data-color');
      
      try {
        var owl = $('.pdp-carousel-top');
        owl.trigger('to.owl.carousel', [index, 300]);   
        
      } catch (ex) {
        console.log(ex);
       } finally {             
    	$('.pdp-carousel-top .owl-stage-outer .owl-stage .active form .color-swatch .swatch div[data-value="'+ selectedDataColor +'"]')
        .find('input').prop('checked', true);
      }      
  	});

  	$('.product-thumbs-link-bottom').on('click', function(e) {
      var link = $(this);
      var slide = link.attr('data-slide-index');
      var index = parseInt(slide,10);
      var selectedDataColor = $(this).attr('data-color');      
      
      try {
        var owl = $('.pdp-carousel-bottom');
        owl.trigger('to.owl.carousel', [index, 300]);
      } catch (ex) {
        console.log(ex);     
       } finally {
    	$('.pdp-carousel-bottom .owl-stage-outer .owl-stage .active form .color-swatch .swatch div[data-value="'+ selectedDataColor +'"]')
        .find('input').prop('checked', true);
      }      
  });
  
  /////////////////////////MRIGANKA/////////////////////////
  
  $('.pdp-slider').on('click', function(e) {
    console.log('PDP');
    var pdp = $(this);
    var posX = pdp.offset().left;
    console.log('pdp click', e.pageX - posX, pdp.width);
  });

  // Swatches
  $('a.grid-view-item__link').each(function() {
      
      var wrapper = this;
      var mainImage = $('img.grid-view-item__image', wrapper)[0];
      var backImage = $('img.collection-hover_img', wrapper)[0];
      var anchor = $('a.grid-view-item__link', wrapper)[0];
      
      var changeImage = function(e) {
        e.preventDefault();
          
        $(mainImage).attr('src', this.dataset.frontimg)
         			.attr('srcset', '')
        			.attr('data-srcset', '');
        $(backImage).attr('src', this.dataset.backimg);
        
        $(wrapper).attr('href', '/products/' + this.dataset.url);
      }
      
      $('.swatches-dt img', wrapper).hover(changeImage);
      $('.swatches-mob img', wrapper).click(changeImage);
      
   });
   // end of swatches
    
  
});